export enum PaymentStatusUI {
  RESERVED = 'reserved',
  COMPLETED = 'completed',
  PENDING = 'pending',
  DECLINED = 'declined',
  REVERSED = 'reversed',
  WAIT_FOR_FUNDS = 'waitForFunds',
  INITIATED = 'initiated',
  UNDER_REVIEW = 'underReview'
}

export enum PaymentStatus {
  // Reserved
  AUTHORIZED = 'AUTHORIZED',
  // Pending
  PENDING = 'PENDING',
  INITIATED = 'INITIATED',
  CONFIRMED = 'CONFIRMED',
  PROCESSING = 'PROCESSING',
  WAITING = 'WAITING',
  ACTIVE = 'ACTIVE',
  // if amlStatusUnderReviewEnabled, then Under Review, otherwise - Pending
  VERIFICATION = 'VERIFICATION',
  SUSPENDED = 'SUSPENDED',
  // Completed
  COMPLETED = 'COMPLETED',
  // Declined
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  REMOVED = 'REMOVED',
  // Reversed
  REVERSED = 'REVERSED',
  // Wait for funds
  WAIT_FOR_FUNDS = 'WAIT_FOR_FUNDS'
}
